import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    defaultMessage: 'Error',
    description: 'capitalized error',
    id: 'MkH71j',
  },
  closeBanner: {
    defaultMessage: 'Close banner',
    description: 'Label for button that closes the banner',
    id: '+yPqxe',
  },
});
